// Wire protocol shared by the browser client and the Node game server.
// Keep this file dependency-free: it is bundled into the client (via Vite)
// and into the server (via tsup). All messages are JSON over a WebSocket.
// v4: combat. Entities now cover players AND monsters (hp/maxHp), plus new
// events for damage, fireballs, teleports (respawn), and money/gold. Breaking.
export const PROTOCOL_VERSION = 4;
// ---------------------------------------------------------------------------
// Encoding / decoding
// ---------------------------------------------------------------------------
export function encode(msg) {
    return JSON.stringify(msg);
}
function isFiniteNumber(v) {
    return typeof v === "number" && Number.isFinite(v);
}
/**
 * Parse and validate an UNTRUSTED client message. Returns null on anything
 * malformed — the server must never throw on bad network input. Every field
 * is type-checked here so handlers downstream can trust the shape.
 */
export function decodeClientMessage(raw) {
    let v;
    try {
        v = JSON.parse(raw);
    }
    catch {
        return null;
    }
    if (typeof v !== "object" || v === null)
        return null;
    const m = v;
    switch (m.t) {
        case "hello":
            if (typeof m.protocol !== "number")
                return null;
            if (m.token !== undefined && typeof m.token !== "string")
                return null;
            if (m.name !== undefined && typeof m.name !== "string")
                return null;
            return {
                t: "hello",
                protocol: m.protocol,
                token: m.token,
                name: m.name,
            };
        case "move":
            if (!isFiniteNumber(m.seq) || !isFiniteNumber(m.x) || !isFiniteNumber(m.y)) {
                return null;
            }
            return { t: "move", seq: m.seq, x: m.x, y: m.y };
        case "attack":
            if (!isFiniteNumber(m.seq) || !isFiniteNumber(m.targetId))
                return null;
            return { t: "attack", seq: m.seq, targetId: m.targetId };
        case "pickup":
            if (!isFiniteNumber(m.moneyId))
                return null;
            return { t: "pickup", moneyId: m.moneyId };
        case "ping":
            if (typeof m.id !== "number")
                return null;
            return { t: "ping", id: m.id };
        case "set_name":
            if (typeof m.name !== "string")
                return null;
            return { t: "set_name", name: m.name };
        case "email_request":
            if (typeof m.email !== "string")
                return null;
            if (m.purpose !== "bind" && m.purpose !== "signin")
                return null;
            return { t: "email_request", email: m.email, purpose: m.purpose };
        case "email_verify":
            if (typeof m.email !== "string" || typeof m.code !== "string")
                return null;
            if (m.purpose !== "bind" && m.purpose !== "signin")
                return null;
            return { t: "email_verify", email: m.email, code: m.code, purpose: m.purpose };
        default:
            return null;
    }
}
/** Parse a server message on the client. The server is trusted, so this is light. */
export function decodeServerMessage(raw) {
    try {
        const v = JSON.parse(raw);
        if (typeof v === "object" && v !== null && typeof v.t === "string") {
            return v;
        }
        return null;
    }
    catch {
        return null;
    }
}
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export function isValidEmail(email) {
    return email.length <= 254 && EMAIL_RE.test(email);
}
/** Strip control chars, collapse whitespace, and clamp a display name. */
export function sanitizeName(name, max) {
    const cleaned = name
        .replace(new RegExp("[\\u0000-\\u001f\\u007f]", "g"), "")
        .replace(/\s+/g, " ")
        .trim();
    return cleaned.slice(0, max);
}
//# sourceMappingURL=protocol.js.map